// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"b15f7804","154":"5061b99f","189":"87048f58","453":"5fb468fe","461":"18085a0a","489":"8e9df93f","637":"5473c467","699":"c328fc06","965":"e5566767"}[chunkId] + ".chunk.js";
};